import { FC } from "react";
import { RouteComponentProps } from "react-router-dom";
import __ from "src/utils/Translations";
import useBasePath from "src/utils/hooks/useBasePath";
import { absencesAbsencesConfigurationWrite } from "src/utils/RoleBasedSecurity/permissions";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import { LogLevel, useLogStatus } from "src/utils/newRelic/useLogStatus";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import Title from "src/Pages/Company/Absences/Title/Title";
import { useFetchCalendar } from "src/Pages/Company/Absences/api/calendars.queries";
import { Loader } from "src/Pages/Company/Absences/Loader/Loader";
import ErrorDataFetching from "src/Components/Error/ErrorDataFetching";
import CalendarForm from "src/Pages/Company/Absences/Calendars/Calendar/CalendarForm";
import PermissionsAlert from "src/Pages/Company/Absences/PermissionsAlert";

interface IMatchParams {
  calendarId: string;
}

const CalendarEdit: FC<RouteComponentProps<IMatchParams>> = ({ match }) => {
  const { calendarId } = match.params;
  const basePath = useBasePath();
  const canWriteAbsencesConfiguration = usePermission(
    absencesAbsencesConfigurationWrite
  );
  const logStatus = useLogStatus();

  if (!calendarId) {
    logStatus({
      level: LogLevel.DEBUG,
      message: "No calendar ID provided.",
      file: "CalendarEdit.tsx",
    });
  }

  const {
    data: calendarData,
    isFetching,
    isSuccess,
    isError,
  } = useFetchCalendar(calendarId);

  return (
    <>
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Lista kalendarzy"),
            to: `${basePath}/absences/calendars`,
          },
          {
            label: __("Edycja kalendarza"),
          },
        ]}
      />
      <Title
        title={`${__("Edycja kalendarza")} ${calendarData?.name || ""}`}
        subtitle={__(
          "Przestrzeń do tworzenia i zarządzania kalendarzem rocznym."
        )}
      />
      {!canWriteAbsencesConfiguration && <PermissionsAlert />}
      {isFetching && <Loader />}
      {isError && <ErrorDataFetching />}
      {isSuccess && (
        <CalendarForm calendarId={calendarId} calendarData={calendarData} />
      )}
    </>
  );
};

export default CalendarEdit;
